/** Grid en pantalla pequeña; fila horizontal desde xl (junto al sidebar fijo). */
export const GUIDE_ITEM_ROW =
  'grid w-full min-w-0 grid-cols-2 gap-x-2 gap-y-3 sm:grid-cols-4 xl:flex xl:flex-nowrap xl:items-start xl:gap-1.5';

export const GIC = {
  product: 'w-full min-w-0 col-span-2 sm:col-span-2 xl:col-span-auto xl:flex-1 xl:min-w-[5.5rem]',
  kardex: 'w-full min-w-0 col-span-2 sm:col-span-1 xl:col-span-auto xl:w-28',
  qty: 'w-full min-w-0 col-span-1 xl:col-span-auto xl:w-16',
  unit: 'w-full min-w-0 col-span-1 xl:col-span-auto xl:w-20',
  project: 'w-full min-w-0 col-span-2 sm:col-span-2 xl:col-span-auto xl:flex-1 xl:min-w-[4.5rem]',
  price: 'w-full min-w-0 col-span-2 sm:col-span-1 xl:col-span-auto xl:w-24',
  priceNarrow: 'w-full min-w-0 col-span-2 sm:col-span-1 xl:col-span-auto xl:w-20',
  igv: 'w-full min-w-0 col-span-1 xl:col-span-auto xl:w-16',
  total: 'w-full min-w-0 col-span-2 sm:col-span-1 xl:col-span-auto xl:w-[7rem]',
  condition: 'w-full min-w-0 col-span-2 sm:col-span-1 xl:col-span-auto xl:w-24',
  actions: 'w-full min-w-0 col-span-1 xl:col-span-auto xl:w-8',
};
